import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-0 text-grey-900" }
const _hoisted_2 = { class: "plus-info-inner-wrapper bg-white border-1 border position-relative my-0 my-sm-5" }
const _hoisted_3 = { class: "d-flex justify-content-between" }
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = { class: "me-2" }
const _hoisted_6 = { class: "title-2 text-grey-900" }
const _hoisted_7 = { class: "d-flex flex-md-row flex-column" }
const _hoisted_8 = { class: "col-md-3 col-12 mb-md-0 mb-5" }
const _hoisted_9 = { class: "title-4 text-grey-900" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "col-md-9 col-12" }
const _hoisted_12 = ["innerHTML"]

import { onMounted } from "vue";

// State
import state from "@/vue/club-advantages/state/state";

// Classes
import { ClubAdvantage } from "@/vue/club-advantages/classes/ClubAdvantage";

// Components
import BorderHorizontal from "@/vue/common/borderHorizontal.vue";

// Props

export default /*@__PURE__*/_defineComponent({
  __name: 'InfantClubPopUp',
  props: {
    advantage: {}
  },
  emits: ["closePopup"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

// Methods
const handleClose = (): void => {
	emit("closePopup");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(props.advantage.cardTitleIcon), {
              width: 32,
              height: 32
            }))
          ]),
          _createElementVNode("div", _hoisted_6, _toDisplayString(props.advantage.title), 1)
        ]),
        _createElementVNode("button", {
          class: "ts-x-black ts-x-md",
          onClick: handleClose
        })
      ]),
      _createVNode(BorderHorizontal),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).infantClubs, (club, club_i) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "shadow-3 border-1 border plus-info-inner-wrapper mb-4",
          key: club_i
        }, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, _toDisplayString(club.clubName), 1),
              _createElementVNode("div", {
                class: "body text-grey-900",
                innerHTML: club.minAndMaxAge
              }, null, 8, _hoisted_10)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", {
                class: "body",
                innerHTML: club.activitiesDescription
              }, null, 8, _hoisted_12)
            ])
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})